<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {

  },

  data: () => ({
    //
  })
}
</script>

<style>
@import './css/Re-Desing/Gobal-Design.css';
@import './css/Re-Desing/Datatable.css';
@import './css/Re-Desing/Search-Item.css';
@import './css/Global.css';
@import './css/Dashboard.css';
@import './css/CreateOrgChart.css';
@import './css/Agency.css';
@import './css/Section.css';
@import './css/Department.css';
@import './css/Title.css';
@import './css/Filter.css';
@import './css/PageNotFound.scss';
</style>
